var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",style:({ backgroundColor: _vm.background, width: _vm.width })},[_c('div',{staticClass:"text",style:({fontSize: _vm.fontSizes[0]+'px', color: _vm.color})},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"value",style:({fontSize: _vm.fontSizes[1]+'px', color: _vm.color})},[_vm._v(_vm._s(_vm.format(_vm.value)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }